import { useMutation } from "@apollo/client/react";
import { GET_REVIEWS, CREATE_REVIEW, CreateReviewMutation, CreateReviewMutationVariables } from "./shared";

export function useCreateReview(appId: number) {
  const [createReview] = useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CREATE_REVIEW, {
    refetchQueries: [ { query: GET_REVIEWS, variables: { appId } } ],
  });

  return createReview;
}
